(function($) {
  var $ = require('jquery');
  var jQueryBridget = require('jquery-bridget');
  var Masonry = require('masonry-layout');
  var imagesLoaded = require('imagesloaded');

  jQueryBridget( 'masonry', Masonry, $ );
  imagesLoaded.makeJQueryPlugin( $ );

  if (!$('#item').length) return

  var $grid = $('#item').masonry({
    itemSelector : '.item'
  });
  $grid.imagesLoaded().progress( function() {
    $grid.masonry('layout');
  });
  $(".item:nth-last-child(-n+2)").append('<p class="item__bdbtm"></>');
})(jQuery);
